const mixin = {
  computed: {
    rowsPerPageArray: () => [10, 15, 25, 50, 100, { text: 'Todos', value: -1 }],
  },
  methods: {
    orderDescList(list, sortBy) {
      let orderedList = JSON.parse(JSON.stringify(list))
      return orderedList.sort((a, b) => {
        return b[sortBy] - a[sortBy]
      })
    },
  },
}

export default mixin
